export const ID = "ID";
export const Technology_Name = "technology_name";
export const TechnologyName = "Technology Name";
export const Actions = "Actions";
export const TechnologyTitle = "Technology";
export const AddTechnology = "Add Technology";
export const EditTechnology = "Edit Technology";
export const DeleteTechnology = "Delete Technology";
export const DeleteMessage = "Are you sure you want to delete this technology?";
